import * as xlsx from 'xlsx'
import saveAs from 'file-saver'

function makeFilename (extraTerm) {
  let year = (new Date()).getFullYear()
  let month = (new Date()).getMonth() + 1
  let date = (new Date()).getDate()
  return `ICP-Brisbane-Stock${extraTerm === undefined ? '' : '-' + extraTerm}-${date}.${month}.${year}.xlsx`
}

function groupBy (array, func) {
  return array.reduce(function (obj, num) {
    let v = func(num)
    if (!obj.hasOwnProperty(v)) {
      obj[v] = []
    }
    obj[v].push(num)
    return obj
  }, {})
}

function addSheet (name, data, workbook) {
  const header = Object.keys(data[0]) // columns names
  let wscols = Array.from({ length: header.length }, (v, k) => {
    return { wch: header[k].length + 5 }
  })
  for (let rowIdx in data) {
    const row = data[rowIdx]
    for (let i = 0; i < wscols.length; i++) {
      let cellLen = row[header[i]].length + 1
      if (cellLen > wscols[i].wch) wscols[i].wch = cellLen
    }
  }
  const workSheet = xlsx.utils.json_to_sheet(data)
  workSheet['!cols'] = wscols
  xlsx.utils.book_append_sheet(workbook, workSheet, name)
}

export default async function (products, markupPercent) {
  const jsonData = products.flatMap(product => {
    return product.skus.map(sku => {
      const price = Number(sku.price * (1.0 + (markupPercent / 100.0))).toFixed(0)
      return {
        'ProductID': product.id.toString(),
        'SkuID': sku.id.toString(),
        'Group': sku.options?.colour?.superGroup,
        'Brand': product.attributes?.brand || '',
        'Type': product?.attributes?.type || '',
        'Range': product?.attributes?.range || '',
        'Name': product.name || '',
        'Stock': sku.stock,
        'Colour': { v: sku.options.colour?.name },
        'Price': { v: price, t: 'n', z: '$#,###.00' },
        'Image': { v: 'Link', t: 's', l: { Target: `https://my.climbicp.com.au/${product.images?.[0]?.url}`, Tooltip: `Image of ${product.name}` } }
      }
    })
  }).sort((a, b) => {
    const compareGroup = a.Group?.localeCompare?.(b.Group)
    const compareBrand = a.Brand?.localeCompare?.(b.Brand)
    const compareRange = a.Range?.localeCompare?.(b.Range)
    return compareGroup || compareBrand || compareRange
  }).filter(item => item.Stock > 0)

  const groupedJsonData = groupBy(JSON.parse(JSON.stringify(jsonData)), x => x.Group)

  const workBook = xlsx.utils.book_new()
  for (let key of Object.keys(groupedJsonData)) {
    let sheetJsonData = groupedJsonData[key]
    sheetJsonData.forEach(d => delete d.ProductID)
    sheetJsonData.forEach(d => delete d.SkuID)
    sheetJsonData.forEach(d => delete d.Group)
    addSheet(key, sheetJsonData, workBook)
  }

  /* bookType can be any supported output type */
  const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' }
  const wbout = xlsx.write(workBook, wopts)

  /* the saveAs call downloads a file on the local machine */
  saveAs(new Blob([wbout], { type: 'application/octet-stream' }), makeFilename())

  // const workBook1 = xlsx.utils.book_new()
  // addSheet('All Holds', jsonData, workBook1)
  // xlsx.writeFile(workBook1, outDir + makeFilename())
}
